import { RichTextInput } from "../../input";
import { useNode, useEditor } from "@craftjs/core";
import React, { useContext, useState } from "react";
import { QuoteSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import { CMSQuoteSettings } from "./cms-settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraPostEditorContext } from "../../post-edit/context";
import CMSIcon from "./cms-icon";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const Quote = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { screen } = useContext(GrigoraDashboardContext) ?? {};

  const {
    actions: { selectNode },
  } = useEditor();

  const { quoteText, quoteCitation, quoteDesign } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-quote": true,
      [`quote-${id}`]: id,
      [`${quoteDesign ? quoteDesign : ""}`]: true,
    },
    blockProps.className,
  );

  const [editable, setEditable] = useState(false);
  const isPostEditor = !!useContext(GrigoraPostEditorContext);
  return (
    <div
      {...blockProps}
      {...(screen === "cms-post-editor"
        ? { ref: (ref) => connect(ref) }
        : { ref: (ref) => connect(drag(ref)) })}
      onClick={() => selected && setEditable(true)}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Quote(
        id,
        props,
        isPostEditor,
      )}`}</style>
      <blockquote className="quote">
        <RichTextInput
          value={quoteText}
          onChange={(e) => setProp((props) => (props.quoteText = e), 500)}
        />
        {(selected || quoteCitation) &&
        quoteDesign !== "design-2" &&
        quoteDesign !== "design-4" &&
        quoteDesign !== "design-5" ? (
          <RichTextInput
            placeholder="Citation..."
            tagName="cite"
            value={quoteCitation}
            onChange={(e) => setProp((props) => (props.quoteCitation = e), 500)}
          />
        ) : null}
      </blockquote>
    </div>
  );
};

// To Avoid Mangling in Production
Quote.displayName = "Quote";

Quote.craft = {
  name: "Quote",
  props: {},
  related: {
    settings: QuoteSettings,
    CMSsettings: CMSQuoteSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "basic",
    keywords: ["Quote", "Saying", "Citation"],
  },
  custom: {
    name: "Quote",
    slug: "grigora/quote",
  },
};
